export default __webpack_public_path__ + "static/media/filters.08293b53.png";